import playerClient from "../middleware/playerClient";

/** @see https://crm-api.inversatechnosoft.com/api/swagger/frontend#/Player/get_api_v1_player_me */
export const PLAYER_ME_ENDPOINT = "me";

export async function getPlayerMe() {
  const response = await playerClient.get(PLAYER_ME_ENDPOINT, {
    headers: { accept: "application/json" },
  });
  return response.data;
}

/** PUT api/v1/player/me — only the fields sent are changed. */
export async function updatePlayerMe(payload) {
  const response = await playerClient.put(PLAYER_ME_ENDPOINT, payload, {
    headers: { accept: "application/json" },
  });
  return response.data;
}

// player games lists: GET api/v1/player/games/{last-played|favourites}?limit&offset
export const PLAYER_FAVORITES_ENDPOINT = "games/favourites";
export const PLAYER_LAST_PLAYED_ENDPOINT = "games/last-played";

/** Response: { success, data: [game], total } */
export async function getFavoriteGamesRequest() {
  const response = await playerClient.get(PLAYER_FAVORITES_ENDPOINT, {
    params: { limit: 20, offset: 0 },
    headers: { accept: "application/json" },
  });
  return response.data;
}

export async function getLastPlayedGamesRequest() {
  const response = await playerClient.get(PLAYER_LAST_PLAYED_ENDPOINT, {
    params: { limit: 20, offset: 0 },
    headers: { accept: "application/json" },
  });
  return response.data;
}

/** POST api/v1/player/games/{id}/favourite — { success, data: { game_id, is_favorite } } */
export async function addFavouriteGameRequest(gameId) {
  const response = await playerClient.post(`games/${gameId}/favourite`, null, {
    headers: { accept: "application/json" },
  });
  return response.data;
}

/** DELETE api/v1/player/games/{id}/favourite — same shape, is_favorite false */
export async function removeFavouriteGameRequest(gameId) {
  const response = await playerClient.delete(`games/${gameId}/favourite`, {
    headers: { accept: "application/json" },
  });
  return response.data;
}
